module.exports = __webpack_public_path__ + "img/login_bsgs.b08b5ea1.svg";